import { useInjection } from '@cp/shared/di';
import { INTENTION_SERVICE } from './di';

export const useIntentionService = () => useInjection(INTENTION_SERVICE);
